import React from 'react'
import Select from 'react-select'
import {FormattedMessage} from 'react-intl'

import TimeField from './TimeField'
import WeekDayPicker from './WeekDayPicker'


const PoiBottom = ({poi, options, onChange, index, frequency, onToggleEditFrequency}) => {
  return <div className="poi-bottom">
    <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
      <div className="poi-arrival">
        <div className="column-header">
          <FormattedMessage id="Arrival" defaultMessage="Arrival"/>
        </div>
        <TimeField value={poi.arrivalTime} onChange={onChange(['pois', index, 'arrivalTime'])}/>
      </div>
      <div className="poi-departure">
        <div className="column-header">
          <FormattedMessage id="Departure" defaultMessage="Departure"/>
        </div>
        <TimeField value={poi.departureTime} onChange={onChange(['pois', index, 'departureTime'])}/>
      </div>
    </div>
    
    <div className="poi-frequency">
      <div className="column-header">    
        <FormattedMessage id="Frequency" defaultMessage="Frequency"/>
      </div>
      <WeekDayPicker 
                    value={poi.frequency} 
                    isOpen={poi.isEditingFrequency} 
                    onToggle={_ => onToggleEditFrequency(index)} 
                    onChange={onChange(['pois', index, "frequency"])}/>
    </div>
  </div>
}

PoiBottom.propTypes = {
  poi: React.PropTypes.shape({
    frequency: React.PropTypes.string.isRequired,
    arrivalTime: React.PropTypes.string.isRequired,
    departureTime: React.PropTypes.string.isRequired,
    isOpen:  React.PropTypes.bool.isRequired,
    isEditingFrequency: React.PropTypes.bool.isRequired,
  }),
  index: React.PropTypes.number.isRequired,
  onChange: React.PropTypes.func.isRequired,
  onToggleEditFrequency: React.PropTypes.func.isRequired,
}

export default PoiBottom



/** WEBPACK FOOTER **
 ** ./app/components/PoiBottom.jsx
 **/